module.exports = __webpack_public_path__ + "static/media/kindbio-no-text.59515235.svg";